import { render, staticRenderFns } from "./ExplainOneToOne.vue?vue&type=template&id=14f36508&scoped=true&"
import script from "./ExplainOneToOne.vue?vue&type=script&lang=ts&"
export * from "./ExplainOneToOne.vue?vue&type=script&lang=ts&"
import style0 from "./ExplainOneToOne.vue?vue&type=style&index=0&id=14f36508&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f36508",
  null
  
)

export default component.exports